export const projects = [
  {
    id: "proj-1",
    categoryKey: "maisons",
    title: { fr: "Villa de grand standing", en: "High-end villa" },
    location: "Lomé — Baguida, Togo",
    year: "2025",
    type: { fr: "Construction clé en main", en: "Turnkey construction" },
    description: {
      fr: "Conception architecturale et construction complète d'une villa contemporaine de 650 m² : gros œuvre, installations techniques, menuiseries aluminium et finitions haut de gamme.",
      en: "Architectural design and full construction of a 650 m² contemporary villa: structural works, technical systems, aluminium joinery and premium finishes.",
    },
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-2",
    categoryKey: "batiments",
    title: { fr: "Complexe immobilier R+4", en: "R+4 residential complex" },
    location: "Lomé — Adidogomé, Togo",
    year: "2024",
    type: { fr: "Construction de bâtiment", en: "Building construction" },
    description: {
      fr: "Réalisation d'un immeuble résidentiel R+4 de 1 800 m² : études de structure, gros œuvre, réseaux électriques et plomberie, coordination de tous corps de métier.",
      en: "Delivery of a 1,800 m² R+4 residential building: structural studies, structural works, electrical and plumbing networks, coordination of all trades.",
    },
    image: "https://images.unsplash.com/photo-1602757115429-b4190ae087be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-3",
    categoryKey: "metallerie",
    title: { fr: "Charpente métallique industrielle", en: "Industrial steel framework" },
    location: "Port Autonome de Lomé, Togo",
    year: "2025",
    type: { fr: "Charpente & soudure", en: "Steel framing & welding" },
    description: {
      fr: "Fabrication et montage d'une charpente métallique de 2 400 m² pour un entrepôt logistique : calculs de structure, soudure haute précision et levage.",
      en: "Fabrication and erection of a 2,400 m² steel framework for a logistics warehouse: structural calculations, high-precision welding and lifting.",
    },
    image: "https://images.unsplash.com/photo-1563166423-482a8c14b2d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-4",
    categoryKey: "maisons",
    title: { fr: "Résidence contemporaine avec piscine", en: "Contemporary residence with pool" },
    location: "Lomé — Tokoin, Togo",
    year: "2024",
    type: { fr: "Construction & aménagement", en: "Construction & fit-out" },
    description: {
      fr: "Construction d'une résidence de 520 m² avec piscine, aménagements extérieurs paysagers et domotique intégrée pour le confort des occupants.",
      en: "Construction of a 520 m² residence with pool, landscaped outdoor areas and integrated home automation for occupant comfort.",
    },
    image: "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-5",
    categoryKey: "renovation",
    title: { fr: "Réhabilitation d'un siège corporatif", en: "Corporate headquarters rehabilitation" },
    location: "Lomé — Nyékonakpoè, Togo",
    year: "2025",
    type: { fr: "Rénovation & réhabilitation", en: "Renovation & rehabilitation" },
    description: {
      fr: "Réhabilitation complète d'un siège d'entreprise de 950 m² : renforcement structurel, mise aux normes électriques, climatisation et réaménagement des espaces de travail.",
      en: "Full rehabilitation of a 950 m² corporate headquarters: structural reinforcement, electrical compliance, air conditioning and workspace reconfiguration.",
    },
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-6",
    categoryKey: "metallerie",
    title: { fr: "Ouvrage de génie civil & soudures", en: "Civil engineering & welding works" },
    location: "Kpalimé, Togo",
    year: "2024",
    type: { fr: "Métallerie spécialisée", en: "Specialised metalwork" },
    description: {
      fr: "Conception et réalisation d'ouvrages métalliques spéciaux : passerelles, escaliers industriels et garde-corps avec soudures contrôlées.",
      en: "Design and delivery of special metal structures: walkways, industrial staircases and guardrails with controlled welds.",
    },
    image: "https://images.unsplash.com/photo-1623489254637-a2dd8375243d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-7",
    categoryKey: "electricite",
    title: { fr: "Installation électrique tertiaire", en: "Commercial electrical installation" },
    location: "Lomé — Centre-ville, Togo",
    year: "2025",
    type: { fr: "Électricité bâtiment", en: "Building electrical systems" },
    description: {
      fr: "Conception et réalisation de l'installation électrique complète d'un immeuble tertiaire : TGBT, câblage, éclairage, onduleurs et mise à la terre.",
      en: "Design and delivery of the complete electrical installation of a commercial building: main switchboard, wiring, lighting, UPS and earthing.",
    },
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-8",
    categoryKey: "plomberie",
    title: { fr: "Réseaux de plomberie sanitaire", en: "Sanitary plumbing networks" },
    location: "Lomé — Agoè, Togo",
    year: "2024",
    type: { fr: "Plomberie", en: "Plumbing" },
    description: {
      fr: "Installation des réseaux d'alimentation et d'évacuation d'un ensemble résidentiel : plomberie sanitaire, équipements et mise en service.",
      en: "Installation of supply and drainage networks for a residential complex: sanitary plumbing, equipment and commissioning.",
    },
    image: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-9",
    categoryKey: "menuiserie",
    title: { fr: "Menuiserie aluminium de bureaux", en: "Office aluminium joinery" },
    location: "Lomé — Boulevard du 13 Janvier, Togo",
    year: "2025",
    type: { fr: "Menuiserie aluminium & vitrerie", en: "Aluminium joinery & glazing" },
    description: {
      fr: "Fabrication et pose de façades vitrées, cloisons et portes en aluminium pour un plateau de bureaux : isolation phonique et finitions premium.",
      en: "Fabrication and installation of glazed facades, partitions and aluminium doors for an office floor: acoustic insulation and premium finishes.",
    },
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-10",
    categoryKey: "amenagement",
    title: { fr: "Aménagement intérieur d'une villa", en: "Villa interior fit-out" },
    location: "Lomé — Hedzranawoé, Togo",
    year: "2025",
    type: { fr: "Aménagement intérieur", en: "Interior fit-out" },
    description: {
      fr: "Aménagement intérieur complet : faux plafonds, peinture décorative, carrelage grand format, mobilier sur mesure et éclairage architectural.",
      en: "Complete interior fit-out: suspended ceilings, decorative painting, large-format tiling, custom furniture and architectural lighting.",
    },
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-11",
    categoryKey: "batiments",
    title: { fr: "Immeuble de bureaux", en: "Office building" },
    location: "Lomé — Boulevard du Mono, Togo",
    year: "2023",
    type: { fr: "Construction de bâtiment", en: "Building construction" },
    description: {
      fr: "Construction d'un immeuble de bureaux moderne : structure béton armé, façade contemporaine, équipements techniques et aménagements extérieurs.",
      en: "Construction of a modern office building: reinforced concrete structure, contemporary facade, technical systems and outdoor works.",
    },
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
  {
    id: "proj-12",
    categoryKey: "renovation",
    title: { fr: "Rénovation complète d'une villa", en: "Full villa renovation" },
    location: "Aného, Togo",
    year: "2024",
    type: { fr: "Rénovation", en: "Renovation" },
    description: {
      fr: "Rénovation complète d'une villa : reprise de toiture, réfection des réseaux, nouvelle cuisine et modernisation des espaces de vie.",
      en: "Full renovation of a villa: roof refurbishment, network renewal, new kitchen and modernised living spaces.",
    },
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1527335988388-b40ee248d80c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000&auto=format&fit=crop";

export const poleImages = {
  "etudes-architecture-construction":
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  "metallerie-soudure-charpente":
    "https://images.unsplash.com/photo-1558227691-41ea78d1f631?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  "technique-du-batiment":
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  "menuiserie-vitrerie":
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  "finition-amenagement":
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
  "fourniture-negoce-materiaux":
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
};

export const aboutImage =
  "https://images.pexels.com/photos/8960943/pexels-photo-8960943.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";
